<div class="visitor-type-condition-editor" *ngIf="condition" [formGroup]="detailsFormGroup">

  <div class="row">
    <mat-form-field class="flex-grow" *ngIf="visitorRoles != null && visitorRoles.length > 0" appearance="fill">
      <mat-label>
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.visit.visitor-role-condition-editor.visitor-role"></sc-dictionary-label>
      </mat-label>
      <mat-select formControlName="visitorRole" name="visitorRole">
        <mat-option *ngFor="let o of visitorRoles" [value]="o.id">
          <sc-dictionary-label [dictionaryKey]="o.nameDictionaryKey"></sc-dictionary-label>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
